import { FC } from 'react';
import { ReactComponent as InfoSvg } from 'resources/images/info.svg';
import { Flex, Box, Text, Button, Center, Icon } from '@chakra-ui/react';

interface ErrorBoundaryDialogProps {
  onTryAgain?: () => void;
}

export const ErrorBoundaryMessage: FC<ErrorBoundaryDialogProps> = ({
  onTryAgain,
}) => (
  <Center height="full">
    <Flex py={10} direction="column" alignItems="center" textAlign="center">
      <Icon as={InfoSvg} color="M.70" width="96px" height="96px" mx="auto" />
      <Box pt={8} pb={1}>
        <Text fontSize="xl" fontWeight={600}>
          Something went wrong...
        </Text>
      </Box>
      <Text fontSize="md">Please try again</Text>
      {onTryAgain && (
        <Button onClick={onTryAgain} mt={6} size="md">
          Try again
        </Button>
      )}
    </Flex>
  </Center>
);
